import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { useLocation } from "react-router-dom";
import SpotifyDock from "./SpotifyDock";

const DESKTOP_QUERY = "(hover: hover) and (pointer: fine) and (min-width: 769px)";

export default function Footer() {
  const { pathname } = useLocation();
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(DESKTOP_QUERY).matches : false,
  );

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY);
    const sync = () => setIsDesktop(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  const showSpotify = pathname !== "/" && isDesktop;

  return (
    <>
      <div className="homepage-footer">
        <a
          href="https://instagram.com/gorillianunchained?igshid=OGQ5ZDc2ODk2ZA=="
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} className="fa-icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/ian-miller-gorillian"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faLinkedin} className="fa-icon" />
        </a>
        <a
          href="https://github.com/gorillian"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faGithub} className="fa-icon" />
        </a>
        <a href="mailto:the.ianwmiller@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} className="fa-icon" />
        </a>
      </div>
      {showSpotify && <SpotifyDock />}
    </>
  );
}
